module.exports = __webpack_public_path__ + "media/MRI-exemplo.b4f80e7e.mp3";